import {
  EntitiesGetResponse,
  Entity,
  EntityCreateResponse,
  ResponseEnvelop
} from './responses';

export enum LocationState {
  Active = 'active',
  Suspended = 'suspended'
}

export interface Location extends Entity {
  state: LocationState;
  country: string;
  post_code: string;
  city: string;
  delivery_instructions: string;
  campus: string;
  building: string;
  latitude: number;
  longitude: number;
  floor: string;
  room: string;
  address_other: string;
  address_line1: string;
  address_line2: string;
  api_city_id: number;
}

export type LocationsResponse = EntitiesGetResponse<Location[]>;
export type LocationResponse = ResponseEnvelop<Location>;
export type LocationCreateResponse = EntityCreateResponse;

export interface LocationPayload {
  address_id: string;
  campus?: string;
  delivery_instructions?: string;
  floor?: string;
  state?: LocationState;
}

export interface City extends Entity {
  name: string;
  platform_city_id: number;
}

export type CitiesResponse = EntitiesGetResponse<City[]>;

export type LocationAutocompleteResponse = EntitiesGetResponse<
  GeolocatorAddress[]
>;

export interface GeolocatorAddress {
  address: {
    id: string;
    formatted_address: string;
  };
}
